export const DATE_FORMAT = "DD.MM.YYYY.";
export const TIME_FORMAT = "HH:mm";
export const START_DATE_FORMAT = "YYYY-MM-DDT00:00:00[Z]";
export const END_DATE_FORMAT = "YYYY-MM-DDT23:59:59[Z]";
export const DATE_TIME_FORMAT = "DD.MM.YYYY. HH:mm";
export const numbersRegExp = /^[0-9]*$/;
export const DATE_PICKER_PLACEHOLDER = "Изабери датум";
export const RANGE_PICKER_PLACEHOLDERS: [string, string] = [
  "Почетни датум",
  "Крајњи датум",
];
export const RANGE_PICKER_PAYLOAD_FORMAT = "YYYY.MM.DD HH:mm";
export const STATUS_FILTER_OPTIONS = [
  { label: "Активан", value: true },
  { label: "Неактиван", value: false },
];
